import { useEffect, useRef, useCallback } from 'react';
import { useMsal } from "@azure/msal-react";

const SessionTimeout = () => {
    const { instance, accounts } = useMsal();
    const timeoutRef = useRef(null);
    const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes

    const logout = useCallback(() => {
        if (accounts.length > 0) {
            instance.logoutPopup().catch(e => console.error(e));
        }
    }, [accounts, instance]);

    const resetTimer = useCallback(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(logout, INACTIVITY_LIMIT);
    }, [logout, INACTIVITY_LIMIT]);

    useEffect(() => {
        if (accounts.length === 0) return;

        const events = ['mousemove', 'keydown', 'click', 'scroll'];

        events.forEach(event => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer(); // Start timer on mount

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [accounts, resetTimer]);

    return null; // This component doesn't render anything visible
};

export default SessionTimeout;
